module.exports = __webpack_public_path__ + "static/media/final-banner.3d75bf1b.jpg";